import { Component, OnInit } from '@angular/core'
import { GlobalService } from 'src/app/services/global.service'
import { InvoiceService } from 'src/app/services/invoice.service'
import { SubscriptionService } from 'src/app/services/subscription.service'
import { AngularRoutes, ContractStatus, EnumNames, Invoice, InvoiceStatus } from '@parkupp/core'
import { firstValueFrom } from 'rxjs'
import { query, where, collectionData } from '@angular/fire/firestore'

@Component({
    selector: 'app-admin-list-duplicate-invoices',
    templateUrl: './admin-list-duplicate-invoices.component.html',
    styleUrls: ['./admin-list-duplicate-invoices.component.scss'],
})
export class AdminListDuplicateInvoicesComponent implements OnInit {
    invoices: Invoice[] = []
    selectedInvoice: Invoice | null = null
    AngularRoutes = AngularRoutes
    EnumNames = EnumNames

    constructor(public globalService: GlobalService, private invoiceService: InvoiceService, private subscriptionService: SubscriptionService) {}

    ngOnInit(): void {
        this.loadDuplicateInvoices()
    }

    async loadDuplicateInvoices() {
        // Query for all paid first invoices
        const firstInvoicesQuery = query(this.invoiceService.collection, where('reference', '==', 'First Invoice'))
        const snapshots = await firstValueFrom(collectionData(firstInvoicesQuery, { idField: '$key' }))
        const firstInvoices = snapshots.map((doc) => new Invoice(doc))

        // Group invoices by subscription ID
        const invoicesBySubscription = firstInvoices.reduce((acc: Record<string, Invoice[]>, invoice: Invoice) => {
            const subId = invoice.subscriptionRef?.id
            if (subId) {
                if (!acc[subId]) {
                    acc[subId] = []
                }
                acc[subId].push(invoice)
            }
            return acc
        }, {} as Record<string, Invoice[]>)

        // Get all invoices from subscriptions that have duplicates
        this.invoices = Object.values(invoicesBySubscription)
            .filter((invoices: Invoice[]) => invoices.length >= 2)
            .flat()
    }

    showContextMenu(event: MouseEvent, invoice: Invoice) {
        event.preventDefault()
        this.selectedInvoice = invoice
        this.globalService.contextMenuItems = [
            {
                label: 'View Invoice',
                icon: 'fas fa-eye',
                action: () => {
                    if (invoice.clientRef) {
                        window.open(`/client/${invoice.clientRef.id}/${AngularRoutes.INVOICE}/${invoice.$key}`, '_blank')
                    }
                },
            },
        ]
        this.globalService.showContextMenu(event)
    }
}
